import React from 'react';
import ErrorPage from '../ErrorPage';

const Empty = () => <ErrorPage showCode={false} code='200' msg='系统正在建设中敬请期待...' />;

export default Empty;
